module.exports = __webpack_public_path__ + "img/playbtn.3b7f2d97.svg";